const base64urlDecodeToUtf8 = (segment: string) => {
  let base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
  const remainderLength = base64.length % 4
  if (remainderLength === 1)
    throw new Error('InvalidLengthError: Input base64url string is the wrong length to be decoded')
  if (remainderLength) base64 += '='.repeat(4 - remainderLength)

  const binaryString = atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  for (let index = 0; index < binaryString.length; index++) bytes[index] = binaryString.charCodeAt(index)

  return new TextDecoder('utf-8', { fatal: false }).decode(bytes)
}

export const decodeJwt = <T>(token: string): T | null => {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) throw new Error('InvalidTokenError: JWT must have 3 parts')

    const payloadSegment = parts[1]
    if (!payloadSegment) throw new Error('InvalidTokenError: JWT payload segment is missing')

    const decodedPayload = base64urlDecodeToUtf8(payloadSegment)

    return JSON.parse(decodedPayload) as T
  } catch {
    return null
  }
}
